import { Transition } from 'components/Transition';
import { TransitionItem } from 'components/Transition';
import { useEffect } from 'libs/react';
import { useState } from 'libs/react';
import { useValue } from 'libs/react';
import { React } from 'libs/react';
import { useForm } from 'components/form/Form';
import './Reveal.scss';
/**
 * @component Reveal
 * @since 1.0.0
 */
export function Reveal(props) {
    // TODO
    // Make leave work too
    const { enter, presentClassName, dismissClassName, presentDuration, dismissDuration } = Object.assign({ presentClassName: 'reveal-present', dismissClassName: 'reveal-dismiss', presentDuration: 750, dismissDuration: 750 }, props);
    const self = useValue(() => ({
        evaluate: null
    }));
    const form = useForm();
    const [display, setDisplay] = useState(false);
    /**
     * @function onFormChange
     * @since 1.0.0
     * @hidden
     */
    function onFormChange() {
        const evaluate = self.evaluate;
        if (evaluate) {
            setDisplay(evaluate(form));
        }
    }
    /**
     * @function onBeforePresent
     * @since 1.0.0
     * @hidden
     */
    function onBeforePresent(node) {
        node.style.setProperty('--scroll-width', node.scrollWidth + 'px');
        node.style.setProperty('--scroll-height', node.scrollHeight + 'px');
    }
    /**
     * @function onBeforeDismiss
     * @since 1.0.0
     * @hidden
     */
    function onBeforeDismiss(node) {
        node.style.setProperty('--scroll-width', node.scrollWidth + 'px');
        node.style.setProperty('--scroll-height', node.scrollHeight + 'px');
        const next = node.nextElementSibling;
        if (next == null && node.previousElementSibling) {
            node.previousElementSibling.classList.add('will-be-last-child');
        }
    }
    /**
     * @function onBeforeDismiss
     * @since 1.0.0
     * @hidden
     */
    function onAfterDismiss(node) {
        const next = node.nextElementSibling;
        if (next == null && node.previousElementSibling) {
            node.previousElementSibling.classList.remove('will-be-last-child');
        }
    }
    useEffect(() => {
        self.evaluate = null;
        switch (typeof enter) {
            case 'string':
                self.evaluate = compile(enter);
                return;
            case 'number':
                self.evaluate = returns(enter);
                break;
            case 'boolean':
                self.evaluate = returns(enter);
                return;
            case 'function':
                self.evaluate = enter;
                return;
        }
    }, [enter]);
    useEffect(() => {
        form.appendChangeListener(onFormChange);
        return () => {
            form.removeChangeListener(onFormChange);
        };
    }, []);
    useEffect(() => {
        onFormChange();
    }, []);
    if (enter == null) {
        return props.children;
    }
    return (React.createElement(Transition, { presentClassName: presentClassName, dismissClassName: dismissClassName, presentDuration: presentDuration, dismissDuration: dismissDuration, onBeforePresent: onBeforePresent, onBeforeDismiss: onBeforeDismiss, onAfterDismiss: onAfterDismiss },
        React.createElement(TransitionItem, { key: "reveal", when: display }, props.children)));
}
/**
 * @function compile
 * @since 1.0.0
 * @hidden
 */
function compile(expression) {
    return new Function('form', 'return ' +
        expression.replace(/#([a-zA-Z_.]+)/gim, (match, value) => {
            return `form.getValue('${value}')`;
        }));
}
/**
 * @function returns
 * @since 1.0.0
 * @hidden
 */
function returns(value) {
    return function () {
        return Boolean(value);
    };
}
